import LandingPage from "./LandingPage";
import { logisticsContent } from "./content/logistics";

export default function LogisticsPage() {
  return <LandingPage content={logisticsContent} />;
}
